import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('ContentWrapper')(() => css({
    position: 'relative',
    maxHeight: 'calc(100dvh - 100px)',
    overflowY: 'scroll',
    overflowX: 'hidden',
    mr: '-30px',
    pr: '30px',
    pb: '5px',
}));
themeStyles.addBaseStyles('TrimPanelWrapper')(() => css({
    position: 'sticky',
    display: 'block',
    backgroundColor: 'white',
    top: '-1px',
    marginTop: '-2px',
    zIndex: 10,
}));
export default themeStyles;
